export const committeeMemberRoleGroups: Record<string, string[]> = {
  create: ['createMeetings', 'createResolutionProjects'],
  write: ['takingNotes'],
  edit: ['reviewMeetings', 'createDocumentRecords'],
  sign: ['signMinutes', 'signResolutions']
};
